<!-- eslint-disable -->
<template lang="pug">
    transition(name='fade')
        .detective-modal.modal.is-active(:class="displayModal && 'is-active'" v-show='displayModal')
            .modal-background(@click="$emit('close')")
            .modal-card(:class="{'continents-modal': isContinentsModal}")
                i.fa.fa-times-circle(@click="$emit('close')" aria-hidden='true')
                .modal-card-body
                    slot(name='body')
</template>

<script>
    /*eslint-disable*/
    export default {
        props: {
            title: String,
            isContinentsModal: Boolean,
            displayModal: Boolean
        }
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/sass/detective/modals.scss";

    .modal {
        bottom: 0;
        left: 0;
        position: fixed;
        right: 0;
        top: 0;
        align-items: center;
        display: none;
        justify-content: center;
        overflow: hidden;
        z-index: 1986;
    }
    .modal.is-active {
        display: flex;
    }
    .modal-background {
        bottom: 0;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
    }
    .modal-card {
        position: relative;
    }
    .modal-card-body {
        padding: 1rem;
    }
</style>
